import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            // Define a datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border',
            // Enable row selection
            select: true,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for rating with a unique identifier
                    id: 'rating',
                    // Header is empty for this column
                    header: '',
                    // Set the width of the column
                    width: 50,
                    // Set the height of the column
                    height: 25,
                    // Template function to render the cell content
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('TokenLocalEdit', 'Edit')) {
                            // Return an edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return the same edit icon if permission is not granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        }
                    },
                },
                // Column for date with localization
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' },
                // Column for user with localization
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' },
                {
                    // Column for type with localization and combo editor
                    id: 'Type',
                    header: _('Tipo'),
                    width: 100,
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: '0', value: _('Local') },
                        { id: '2', value: _('Box') },
                    ],
                    sort: 'int',
                },
                {
                    // Column for state with localization and combo editor
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'E', value: _('Expirado') },
                    ],
                    width: 150,
                    sort: 'int',
                },
                // Column for token code with localization
                { id: 'Token', header: _('Código'), width: 300, sort: 'int' },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit token local dialog
                    $$('edittokenLocal').show();
                },
            },
            // Disable editing of the datatable
            editable: false,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // URL for fetching user security data, including the current user ID
            url: devConfig.geturlApi() + '/UserManagement/GetUserSecurityL?FromId=' + cur_user + '&',
        }; // Placeholder for configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);
        // Access the localization service for translation purposes
        const _ = this.app.getService('locale')._;
        // Store the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Listen for the 'generateTokenBetShop:filter' event to apply filters
        this.on(this.app, 'generateTokenBetShop:filter', (filterData) => {
            // Convert filterData object entries into an array
            var object = Object.entries(filterData);
            // Initialize a string to build the query parameters
            var string1 = '';
            // Iterate through each entry in the filter data
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log the date range for debugging
                        // Append dateFrom and dateTo to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle cases where the value is an object (e.g., date range)
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date for the query string
                                    var dateFrom =
                                        'FromDateLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append the formatted start date to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle the 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date for the query string
                                        var dateTo =
                                            'ToDateLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append the formatted end date to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the query string
            string1 = string1 + '&UserId=' + cur_user;
            // Clear the grid data before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the starting index and page size
                    filter + // Apply any additional filters
                    '&sort[' +
                    by + // Specify the column to sort by
                    ']=' +
                    dir, // Specify the sort direction (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item based on its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Attach an event handler for the 'onBeforeEditStart' event of the grid
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Retrieve the item to be edited based on its ID
            console.log(item); // Log the item details to the console
            if (id.column == 'State') {
                // Check if the edited column is 'State'
                var options = this.getColumnConfig('Action').collection; // Get the collection of options for the 'Action' column
                if (item.State == 'A') {
                    // If the item's state is 'A'
                    options.remove('A'); // Remove option 'A' from the collection
                } else if (item.State == 'I') {
                    // If the item's state is 'I'
                    options.remove('I'); // Remove option 'I' from the collection
                } else {
                    return false; // Prevent editing if the state is neither 'A' nor 'I'
                }
                console.log(id); // Log the ID of the item being edited
            }
        });
        grid.attachEvent(
            'onAfterEditStop', // Event triggered after editing a cell
            function (state, editor, ignoreUpdate) {
                console.log(state); // Log the current state of the edited cell
                var item = this.getItem(editor.row); // Retrieve the item corresponding to the edited row
                console.log(item); // Log the retrieved item
                if (state.value != state.old) {
                    // Check if the new value is different from the old value
                    if (state.value == 'A') {
                        // If the new value is 'A'
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set the content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + // Construct the API URL
                                    'Client/AllowWithdrawalRequests',
                                '{ "Id":' + item.Id + '}', // Send the item ID in the request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'P'; // Update the item's state to 'P' on success
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                    if (state.value == 'P') {
                        // If the new value is 'P'
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set the content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + // Construct the API URL
                                    'Client/PayWithdrawalRequests',
                                '{ "Id":' + item.Id + '}', // Send the item ID in the request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'I'; // Update the item's state to 'I' on success
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                    if (state.value == 'E') {
                        // If the new value is 'E'
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set the content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + // Construct the API URL
                                    'Client/CancelClientRequests',
                                '{ "Id":' + item.Id + '}', // Send the item ID in the request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error! ')); // Display an error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'E'; // Update the item's state to 'E' on success
                                        webix.message('Cell value was changed'); // Notify the user of the change
                                    },
                                },
                            );
                    }
                }
            },
        );
        // Listen for the 'player:select' event on the app instance
        this.on(this.app, 'player:select', (id) => {
            // Load grid data with specified parameters including start, count, and FromId
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        });

        // Create a modal window for editing a token
        var popup = webix.ui({
            view: 'window',
            id: 'edittokenLocal',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window header
                    { view: 'label', label: _('Editar Proveedor') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the window when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form',
                id: 'editform',
                elements: [
                    {
                        view: 'text',
                        label: _('Fecha'), // Label for the date field
                        name: 'Date',
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'text',
                        label: _('Usuario'), // Label for the user field
                        name: 'User',
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'combo',
                        label: _('Tipo'), // Label for the type selection
                        name: 'Type',
                        options: [
                            { id: '0', value: _('Local') }, // Option for Local type
                            { id: '2', value: _('Box') }, // Option for Box type
                        ],
                        readonly: true, // Make the field read-only
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Label for the state selection
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for Activated state
                            { id: 'E', value: _('Expirado') }, // Option for Expired state
                        ],
                    },
                    { view: 'text', label: _('Codigo'), name: 'Token' }, // Field for token code
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Label for the cancel button
                                // Close the window when the button is clicked
                                click: function () {
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Label for the save button
                                // Handle the save action when the button is clicked
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'UserManagement/SaveUserSecurityTokenCustom',
                                            values, // Send form values in the request
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Cell value was changed', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data with updated parameters
                                                    );
                                                },
                                            },
                                        );
                                    $$('editform').setValues(
                                        $$('editform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Close the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Attach a double-click event handler to the grid
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Retrieve the item associated with the given ID
            var item = this.getItem(id);
            // Show the popup when an item is double-clicked
            popup.show();
        });

        // Bind the edit form to the data table for data manipulation
        $$('editform').bind($$('datatable')); // Placeholder for initialization content
    }
}

// FILE DOCUMENTED
